// /opt/isp_erp/frontend/src/api/callcenter.api.js
import axios from './axios';
import { getToken } from '../store/auth.store';

// =============== TICKETS ===============

export async function getCallCenterTickets(params = {}) {
  try {
    const token = getToken();
    const response = await axios.get('/call-center/tickets', {
      params,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener tickets:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function getCallCenterTicket(id) {
  try {
    const token = getToken();
    const response = await axios.get(`/call-center/tickets/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener ticket:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function createCallCenterTicket(data) {
  try {
    const token = getToken();
    const response = await axios.post('/call-center/tickets', data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al crear ticket:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// =============== ASIGNACIONES ===============

export async function assignToN1(ticketId, data) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${ticketId}/assign-n1`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al asignar a N1:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function assignToN2(ticketId, data) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${ticketId}/assign-n2`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al asignar a N2:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function assignToSupervisor(ticketId, data) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${ticketId}/assign-supervisor`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al asignar a Supervisor:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// =============== ESCALACIONES ===============

export async function escalateToN2(ticketId, data) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${ticketId}/escalate-n2`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al escalar a N2:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function escalateToSupervisor(ticketId, data) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${ticketId}/escalate-supervisor`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al escalar a Supervisor:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// =============== RESOLUCIÓN Y CIERRE ===============

export async function resolveCallCenterTicket(ticketId, data) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${ticketId}/resolve`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al resolver ticket:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function closeCallCenterTicket(ticketId, data = null) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${ticketId}/close`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al cerrar ticket:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// =============== INTERACCIONES ===============

export async function addInteraction(ticketId, data) {
  try {
    const token = getToken();
    const response = await axios.post(`/call-center/tickets/${ticketId}/interactions`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al agregar interacción:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function getInteractions(ticketId) {
  try {
    const token = getToken();
    const response = await axios.get(`/call-center/tickets/${ticketId}/interactions`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener interacciones:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// =============== ESTADÍSTICAS ===============

export async function getCallCenterStats(params = {}) {
  try {
    const token = getToken();
    const response = await axios.get('/call-center/stats/general', {
      params,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener estadísticas:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function getTechnicianStats(params = {}) {
  try {
    const token = getToken();
    const response = await axios.get('/call-center/stats/technicians', {
      params,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener estadísticas por técnico:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function getDailyStats(days = 7) {
  try {
    const token = getToken();
    const response = await axios.get(`/call-center/stats/daily?days=${days}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener estadísticas diarias:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// =============== CLIENTES ===============

export async function searchCustomers(searchTerm) {
  try {
    const token = getToken();
    const response = await axios.get('/customers/search', {
      params: { search: searchTerm, limit: 20 },
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log('🔍 Clientes encontrados:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al buscar clientes:', error.response?.data || error.message);
    return [];
  }
}

export async function getCustomerTickets(customerId) {
  try {
    const token = getToken();
    const response = await axios.get('/call-center/tickets', {
      params: { customer_id: customerId },
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener tickets del cliente:', error.response?.data || error.message);
    return [];
  }
}

// =============== EDITAR Y ELIMINAR ===============

export async function updateCallCenterTicket(id, data) {
  try {
    const token = getToken();
    const response = await axios.put(`/call-center/tickets/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar ticket:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export async function deleteCallCenterTicket(id) {
  try {
    const token = getToken();
    const response = await axios.delete(`/call-center/tickets/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error al eliminar ticket:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
}
